export const logo = process.env.REACT_APP_THEME_LOGO; //"https://res.cloudinary.com/xmas/image/upload/v1573715714/pines-and-needles-logo-green.jpg"

export default logo;
